// extracted by mini-css-extract-plugin
export default {"modalCarousel":"styles_modalCarousel__vC0KB","modalCarouselItem":"styles_modalCarouselItem__FuSut"};